import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import 'material-icons/iconfont/material-icons.css';
import { initAdminApiAuth } from './composables/adminApiAuth';

initAdminApiAuth();

const app = createApp(App).use(router).mount('#app');

export default app;


// createApp(App).use(router).mount('#app')
